import React from 'react';
import {Link} from 'react-router-dom';
import {translate} from 'iss/strings';

function TitleBar() {
  return <nav className="navbar navbar-default navbar-static-top">
    <div className="container-fluid">
      <div className="navbar-header">
        <Link className="navbar-brand" to="/">{translate('navigation.title')}</Link>
      </div>
    </div>
  </nav>;
}

export default TitleBar;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/TitleBar.jsx